<template>
  <div class="flex-1">
    <tables-list />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TablesList from "./list/TablesList.vue";

export default {
  name: "Tables.vue",
  components: { TablesList },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
};
</script>

